////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'

//////STYLED//////
const KioskDiagnosticMessageWrapper = styled.div`
	& > span {
		word-wrap: break-word;
		word-break: break-word;
	}
	max-height: 50px;
	overflow-y: auto;
	max-width: 700px;
	margin: auto;
`
//////STYLED//////

const KioskDiagnosticMessage = ({ children }) => {
	return (
		<KioskDiagnosticMessageWrapper>
			<span>{children}</span>
		</KioskDiagnosticMessageWrapper>
	)
}

KioskDiagnosticMessage.propTypes = {}

KioskDiagnosticMessage.defaultPropTypes = {}

export default KioskDiagnosticMessage
